import {
  Popper,
  PopperProps,
  Tab,
  Tabs,
  autocompleteClasses,
  styled as styledComponent,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { styled, Box } from "@mui/system";
import { StyledComponent } from "@emotion/styled";
import {
  FaCheckCircle,
  FaDownload,
  FaExclamationCircle,
  FaFilePdf,
  FaRegTrashAlt,
  FaSearch,
} from "react-icons/fa";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { FaGripLines, FaExclamation } from "react-icons/fa6";

import { accent, colors, others } from "../../../styles/colors";
import fontWeight from "../../../styles/mui/fontWeight";
import { fontSize } from "../../../styles/mui/styles/font";

export const TabsPanelSectionBox = styled(Box)(() => ({
  boxShadow: `1px 1px 8px ${colors.dropShadow[4]}`,
  backgroundColor: colors.white[1],
  borderRadius: "10px",
  marginBottom: "1rem",
}));

export const PanelBox = styled(Box)(() => ({
  padding: "1.2rem 0.5rem 0 0.7rem",
}));

export const PatientHeaderTabs = styled(Tabs)(() => ({
  overflow: "visible",
  "& .MuiTabs-scroller": {
    overflow: "visible",
  },
  marginLeft: "2rem",
  "& .MuiTabs-indicator": {
    backgroundColor: "unset",
  },
  "& .Mui-selected": {
    border: `1px solid ${colors.borders[1]}`,
    color: colors.fonts[18],
    fontSize: ".75rem",
    fontWeight: fontWeight[6],
    opacity: 1,
    textTransform: "uppercase",
    borderBottom: `1px solid ${colors.white[1]}`,
  },
  "& .MuiTabs-flexContainer": {
    paddingTop: "20px",
  },
}));

export const PatientHeaderTab = styled(Tab)(() => ({
  backgroundColor: colors.white[1],
  marginRight: "1rem",
  borderBottomRightRadius: "0px",
  borderBottomLeftRadius: "0px",
  borderTopLeftRadius: "10px",
  borderTopRightRadius: "10px",
  border: `1px solid ${colors.borders[1]}`,
  boxShadow: `1px 1px 8px ${colors.dropShadow[4]}`,
  textTransform: "uppercase",
  overflow: "visible",
  color: colors.fonts[19],
  padding: "0.7rem 0.5rem 0.2rem 0.5rem",
  minHeight: "2.45rem",
  fontSize: ".75rem",
  fontWeight: fontWeight[3],
  opacity: 0.9,
  minWidth: "10.3rem",
}));

export const ReferralGrid = () => ({
  display: "block",
});

export const DetailBox: any = styled(Grid)(() => ({
  padding: "0 1.5rem",
  left: 0,
  right: 0,
  overflow: "hidden",
}));

export const width100PCT = () => ({
  width: "100%",
});

export const FormInputBox = {
  padding: "1rem 3rem 1rem 0",
};

export const OuterGrid = () => ({
  background: others.otherColors[10],
  height: "calc(100vh - 3rem)",
  padding: "2rem 4rem 2rem 4rem",
});

export const TopGrid = () => ({
  display: "flex",
  justifyContent: "center",
  textTransform: "uppercase",
  padding: "0.7rem",
});

export const GridBody = () => ({
  background: others.otherColors[33],
  boxShadow: `0.0487rem 0.15rem 0.78rem ${colors.dropShadow[4]}`,
  opacity: 1,
  padding: "1.2rem 1.6rem 1.5rem 1.5rem",
  marginBottom: "0.8rem",
  borderRadius: "0.5rem",
  display: "flex",
});

export const EligibilityCheckGridBody = () => ({
  background: others.otherColors[33],
  boxShadow: `0.0487rem 0.15rem 0.78rem ${colors.dropShadow[4]}`,
  opacity: 1,
  padding: "1.2rem 1.6rem 0rem 1.5rem",
  borderRadius: "0.5rem",
  display: "flex",
});

export const HorizontalDivider = () => ({
  margin: "1rem 0",
  minWidth: "100%",
  width: "95%",
});

export const AutoComplete = {
  width: "12.5rem",
  minWidth: "7rem",
  maxWidth: "20rem",
  "& .MuiAutocomplete-inputRoot": {
    paddingLeft: 0,
  },
};

export const Search = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
};

export const StyledPopperCheckBoxAutocomplete: StyledComponent<PopperProps> =
  styledComponent(Popper)({
    [`& .${autocompleteClasses.listbox}`]: {
      boxSizing: "border-box",
      "& ul": {
        margin: "2rem",
      },
      "& .MuiAutocomplete-option": {
        cursor: "pointer",
      },
      "&::-webkit-scrollbar": {
        width: ".25rem",
        height: "0.3rem",
        paddingLeft: "2rem",
      },
      "&::-webkit-scrollbar-track": {
        width: 0.4,
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: colors.black[6],
        borderRadius: 0.5,
        width: 0.3,
      },
    },
  });

export const ButtonGrid = () => ({
  display: "flex",
  justifyContent: "flex-end",
  alignItem: "flex-end",
  marginTop: "0.5rem",
});

export const EligibilityButtonGrid = () => ({
  display: "flex",
  justifyContent: "flex-end",
  alignItem: "flex-end",
});

export const ButtonStyle = () => ({
  textTransform: "capitalize",
});

export const FaCheckCircleIcon: any = styled(
  FaCheckCircle as React.ComponentType,
)(() => ({
  color: colors.brand.secondary,
  fontSize: fontSize[12],
}));
export const FaGripLinesIcon: any = styled(FaGripLines as React.ComponentType)(
  () => ({
    color: colors.fonts[5],
  }),
);
export const FaDownloadIcon: any = styled(FaDownload as React.ComponentType)(
  () => ({
    color: colors.primary.main,
  }),
);
export const FaFilePdfIcon: any = styled(FaFilePdf as React.ComponentType)(
  () => ({
    color: colors.primary.main,
    fontSize: fontSize[20],
  }),
);
export const FaExclamationIcon: any = styled(
  FaExclamation as React.ComponentType,
)(() => ({
  color: colors.red[100],
  marginTop: "0.2rem",
}));
export const FaRegTrashAltIcon: any = styled(
  FaRegTrashAlt as React.ComponentType,
)(() => ({
  color: accent.accentOrange[100],
  fontSize: fontSize[12],
}));
export const HeaderTitle = () => ({
  paddingTop: "0.1rem",
  paddingLeft: "1rem",
});

export const GridContainerField = () => ({
  padding: "2rem 0rem",
});

export const FaExclamationCircleIcon: any = styled(
  FaExclamationCircle as React.ComponentType,
)(() => ({
  color: colors.red[100],
  fontSize: "1rem",
}));
export const DocGridBody = () => ({
  background: colors.backgroundColor[9],
  boxShadow: `1px 1px 8px ${colors.dropShadow[4]}`,
  opacity: 1,
  padding: "1.5rem 1.5rem 2rem 2rem",
  marginBottom: "0.8rem",
  paddingBottom: "2.5rem",
  borderRadius: "0.8rem",
  margin: "0rem 2rem 2rem 2rem",
});

export const documentMargin = () => ({
  marginX: "1rem",
});

export const ListItemStyle = {
  minWidth: "1.2rem",
};

export const confirmationDialogBox = () => ({
  "& .MuiDialog-paper": {
    height: "10rem",
    justifyContent: "center",
    borderRadius: "1.5rem",
    maxWidth: "28rem",
    alignItems: "center",
    textAlign: "center",
  },
});

export const DocumentTypeIcon = () => ({
  color: colors.fonts[18],
  padding: "0 0.5rem 0 0.8rem",
});

export const DividerStyle = {
  height: "1.5rem",
  borderRightWidth: "0.15rem",
  paddingLeft: "1rem",
};

export const DocFlexRow = () => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
});
export const CancelButtonGrid = () => ({
  margin: "1rem 0",
  display: "flex",
  alignItems: "center",
  justifyContent: "start",
});

export const NextButtonGrid = () => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "end",
  margin: "1rem 0",
});

export const ButtonMinWidth_Outlined = () => ({
  minWidth: "7rem",
  borderRadius: "2rem",
  color: colors.primary.main,
});
export const ButtonMinWidth = () => ({
  minWidth: "7rem",
  borderRadius: "2rem",
});
export const ButtonErrorWidth = () => ({
  minWidth: "7rem",
  borderRadius: "2rem",
  backgroundColor: colors.backgroundColor[11],
});

export const width50 = () => ({ width: "50%" });
export const width100 = () => ({ width: "100%" });
export const FieldSpacing = () => ({
  paddingY: "1rem",
  paddingX: "1rem",
});

export const SectionSpacing = () => ({
  padding: "0rem 2rem 1rem 2rem",
});

export const AutocompleteTabelCell = () => ({
  padding: "0rem 0rem 0rem 0.3rem",
});

export const CodeTypeTabelCell = () => ({
  padding: "1rem 0rem 1.2rem 0.3rem",
});

export const DescriptionTabelCell = () => ({
  padding: "0rem 0.3rem 0rem 0.3rem",
  "& .MuiTextField-root": {
    width: "80%",
  },
});

export const AutocompleteUI = () => ({
  paddingTop: "1rem",
  maxWidth: "15rem",
  color: colors.fonts[4],
});

export const CodeTypeDropDownWrap = () => ({
  height: "4.4rem",
  maxWidth: "15rem",
  paddingTop: "1rem",
  "& .MuiSelect-nativeInput": {
    position: "relative",
  },

  "& .MuiInputBase-root .css-1qeitpz-MuiSelect-select-MuiInputBase-input-MuiInput-input":
    {
      paddingRight: "0",
      minWidth: "5rem",
      pointerEvents: "none",
    },
});

export const DeleteButton = {
  paddingLeft: "0",
};

export const FaSearchIcon = styled(FaSearch as React.ComponentType)(() => ({
  fontSize: "0.8rem",
}));

export const NextStepButton = () => ({
  svg: {
    marginRight: "1rem",
  },
  borderRadius: "2rem",
  minWidth: "6rem",
});

export const ReauthOpacity = {
  opacity: "0.6",
  paddingLeft: "0.5rem",
};

export const RemoveRowDeleteButton = () => ({
  padding: "1rem 0.3rem 1.2rem 0.3rem",
});

export const SummaryItemContainer = () => ({
  padding: "1rem 1.5rem",
  minHeight: "75vh",
});

export const tableCellColor = () => ({
  backgroundColor: colors.backgrounds[1],
  "& .MuiInput-input": {
    WebkitBoxShadow: `0 0 0 1000px ${colors.backgroundColor[1]} inset`,
  },
});

export const tableCellNoColor = () => ({
  color: colors.backgrounds[6],
});

export const TableHeadStyle = () => ({
  "& .MuiTableCell-root": {
    padding: "0.8rem 0.3rem 1.5rem 0",
    borderBottom: `0.125rem solid ${colors.borders[7]}`,
  },
  "& th:first-of-type": {
    borderRadius: "0.7rem 0 0 0.7rem",
    borderBottom: `0.125rem solid ${colors.borders[7]}`,
  },
  "& th:last-of-type": {
    borderRadius: "0 0.7rem 0.7rem 0",
    borderBottom: `0.125rem solid ${colors.borders[7]}`,
  },
});
export const FiberManualRecordIconStyle: any = styled(FiberManualRecordIcon)(
  () => ({
    width: "0.7rem",
    height: "0.7rem",
  }),
);

export const agencyFieldWidth = () => ({ width: "70%" });

export const ClearButtonGrid = () => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  paddingTop: "2rem",
});

export const ClearErrorButtonBox = () => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: 2,
});

export const verticalScrollStyle = () => ({
  maxHeight: "80vh",
  overflowY: "auto",
  pr: 2,
});

export const mainContentStyle = () => ({
  maxHeight: "80vh",
  height: "80vh",
  overflowY: "auto",
  overflowX: "auto",
  flexWrap: "nowrap",
});

export const overFlowAuto = () => ({
  flex: 1,
  overflowY: "auto",
  overflowX: "auto",
});

export const StyleGridRow = {
  display: "flex",
  justifyContent: "start",
  flexDirection: "row",
};

export const bcbsTcRetroModal = () => ({
  width: "35%",
  backgroundColor: colors.white[1],
  borderRadius: 1,
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  p: 2.5,
  maxHeight: "90vh",
  overflowY: "auto",
});

export const RetroCancelButton = () => ({
  minWidth: "5rem",
  borderRadius: "2rem",
  color: colors.primary.main,
});

export const RetroConfirmButton = () => ({
  minWidth: "5rem",
  borderRadius: "2rem",
});

export const RetroTableCellHeader = () => ({
  fontWeight: fontWeight[4],
});

export const VisitTextField = () => ({
  textAlign: "center",
  width: 50,
});

export const VisitTextFieldOnChange = () => ({
  "& input": { textAlign: "center" },
});

export const IconButtonColor = () => ({
  color: colors.primary.main,
});

export const DisciplineCell = () => ({
  padding: "0.5rem 1rem 0rem 1rem",
});

export const DEDocumentTableHead = () => ({
  position: "sticky",
  top: 0,
  zIndex: 2,
  backgroundColor: colors.primary.light,
});

export const DEDocumentTableContainerStyle = () => ({
  padding: "1rem 4rem 1rem 4rem",
  height: "auto",
  maxHeight: 300,
  overflowY: "auto",
  boxShadow: "none",
  mb: 2,
});

export const FinalModalStyle = () => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

export const OverFlowhidden = () => (
  { textOverflow: "ellipsis", overflow: "hidden" }
)

export const PdfIconeStyle = { flex: "0 0 auto", mr: 0.5}